module.exports = __webpack_public_path__ + "img/concord-business-plans_transparent.906934dd.png";